import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC } from 'react';
import { Close } from '@mui/icons-material';
import { JobOfferIcon } from '../../../../vectors/index';
import DoneIcon from '@mui/icons-material/Done';
import { useNavigate } from 'react-router-dom';

type JobOfferAcceptedModalProps = {
  isOpen: boolean;
  companyName: string | null;
  handleClose: () => void;
};

const JobOfferAcceptedModal: FC<JobOfferAcceptedModalProps> = ({
  isOpen,
  companyName,
  handleClose,
}) => {

  const navigate = useNavigate();

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <Close />
        </IconButton>
        <br />
        <JobOfferIcon />
        <br />
        <Typography variant="h2">
          <b>Onboarding Documents</b>
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} mb={2}>
          <Stack direction="row">
            <Stack alignItems="center" spacing={2}>
              <Typography variant="h4">Nice Work!</Typography>
              <Typography>
                You got the job at <b>{companyName}</b>.
              </Typography>
              <Typography textAlign='center'>
                To finish accepting this offer, <b>{companyName}</b> needs you
                to complete your new hire documents ASAP.
              </Typography>
            </Stack>
          </Stack>
          <Button
            variant="contained"
            color="success"
            onClick={() => navigate('/applicants/onboarding/')}
            startIcon={<DoneIcon />}
          >
            Complete Onboarding Now
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default JobOfferAcceptedModal;
